import { AST } from '@handlebars/parser';

import { joinWithSpaces } from 'utils/stringHelpers';

import { ExpressionSerializer } from '../../expression/serializer';
import { StatementArgsSerializer } from './args';
import { serializeHandlebar, serializeRawHandlebar } from '../../../utils/serializeHandlebar';

export class MustacheStatementSerializer {
  static serialize = (statement: AST.MustacheStatement) => {
    const path = ExpressionSerializer.serialize(statement.path);
    const content = joinWithSpaces([path, StatementArgsSerializer.serialize(statement)]);
    return statement.escaped
      ? serializeHandlebar(content, statement.strip)
      : serializeRawHandlebar(content, statement.strip);
  };
}
